export enum FormLocalizationId {
    ThereAreValidationErrors = "shared-messages.toast.there_are_validation_errors",
}
